module.exports = __webpack_public_path__ + "static/media/view2.918d38fa.jpg";